<template>
  <div
    class="main-conent main-conent-maxheight page-ruibao"
    v-loading="loading"
  >
    <search :loading="loading" @date-change="dateChange" />

    <list
      :data="imgs"
      :loading="loading"
      @show-detail="showDetail"
      @show-model="showModel"
    />

    <div class="paging">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="paging.total"
        :page-size="paging.limit"
        :current-page="paging.page"
        :disabled="loading"
        @current-change="goPage"
      >
      </el-pagination>
    </div>

    <detail
      :visible.sync="drawer"
      :data="detail"
      :opening="openModel"
      @show-image="showModel"
    />
  </div>
</template>

<script>
import Search from './Search'
import List from './List'
import Detail from './Detail'
import showImage from './model'
import * as api from '@/service/ruibao'
import sleep from '@/utlis/sleep'
import moment from 'moment'

export default {
  components: { Search, List, Detail },
  data() {
    return {
      loading: false,
      loadingImg: false,
      drawer: false,
      openModel: false,
      imgs: [],
      paging: { page: 1, limit: 15, total: 0 },
      detail: {}
    }
  },
  mounted() {
    this.getData(1)
  },
  methods: {
    async getData(page, begin, end, t = 0.3) {
      try {
        this.loading = true
        let [{ data }] = await Promise.all([
          api.imgs({
            companyId: this.companyId,
            begin,
            end,
            page,
            limit: this.paging.limit
          }),
          sleep(t)
        ])
        this.imgs = data.data
        this.paging.total = data.paging.total
        this.paging.page = page
      } catch (e) {
        console.log(e)
        this.$message.error(e)
      } finally {
        this.loading = false
      }
    },
    dateChange(begin, end) {
      this.begin = begin
      this.end = end
      this.getData(1, begin, end)
    },
    goPage(page) {
      this.getData(page, this.begin, this.end)
    },
    showDetail(row) {
      this.drawer = true
      this.detail = row
    },
    showModel(row) {
      this.openModel = true
      showImage(
        {
          src: row.predImg,
          title: `[${row.address}] - ${moment(row.createdAt).format(
            'YYYY-MM-DD HH:mm:ss'
          )}`,
          insects: row.insects
        },
        () => this.onImageClose()
      )
    },
    onImageClose() {
      this.openModel = false
    }
  }
}
</script>

<style lang="css" scoped>
.page-ruibao {
  display: flex;
  flex-direction: column;
}
</style>
